import { render, staticRenderFns } from "./AccountsHedbergTable.vue?vue&type=template&id=054690d8&"
import script from "./AccountsHedbergTable.vue?vue&type=script&lang=js&"
export * from "./AccountsHedbergTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports